import { TranslationRequest } from "../model/Translation";
import { TranslationsResponse } from "../model/TranslationsResponse";
import axiosInstance from "../network/AxiosInstance";

const endpoint = process.env.REACT_APP_FACADE_ENDPOINT + "requests";

export async function createTranslationRequest(
    originalLanguage: string,
    toLanguage: string,
    userLocale: string,
    files: string,
    title: string,
    type: string
): Promise<TranslationRequest> {
    return axiosInstance
        .post(`${endpoint}?action=create`, {
            'original_language': originalLanguage,
            'to_language': toLanguage,
            'currency': "USD",
            'user_locale': userLocale,
            'type': type,
            'files': files,
            'title': title,
            'description': `Translation request from: ${originalLanguage} to ${toLanguage}`
        })
        .then((result) => {
            return result.data
        });
}

export async function updateTranslationRequest(
    request: TranslationRequest
): Promise<Boolean> {
    return axiosInstance
        .post(`${endpoint}?action=update`, {
            'user_id': '',
            'translation_request': request
        })
        .then((result) => {
            return result.data
        });
}

export async function fetchMyTranslationRequests(
    lastPartitionKey?: string | undefined,
    lastRangeKey?: string | undefined
): Promise<TranslationsResponse> {
    return axiosInstance
        .post(`${endpoint}?action=fetchByUser`, {
            'last_partition_key': lastPartitionKey ?? '',
            'last_range_key': lastRangeKey ?? ''
        })
        .then((result) => {
            return result.data
        });
}

export async function fetchMyTranslationRequest(
    partitionKey: string,
    rangeKey: string
): Promise<TranslationRequest> {
    return axiosInstance
        .get(`${endpoint}?action=fetch&partitionKey=${partitionKey}&rangeKey=${rangeKey}`)
        .then((result) => {
            return result.data
        });
}

export async function deleteTranslationRequest(
    partitionKey: string,
    rangeKey: string
): Promise<Boolean> {
    return axiosInstance
        .post(`${endpoint}?action=delete`, {
            'partition_key': partitionKey,
            'range_key': rangeKey
        })
        .then((result) => {
            return result.data
        });
}